import assertEventType from 'common/bento/lib/assertEventType';
import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { SaveCapitalDepositHasEuropeanBankAccountDocument } from '../graphql/mutations/saveCapitalDepositHasEuropeanBankAccount.gql';
import { Model } from './model';

export enum Service {
  SaveHasEuropeanBankAccount = 'saveHasEuropeanBankAccount',
}

const services: MachineServices<Model, Service> = {
  saveHasEuropeanBankAccount: async ({ getModuleData }, event) => {
    assertEventType(event, 'SUBMIT');

    const { company } = getModuleData().data.viewer;
    if (!company) {
      throw new Error(
        `saveHasEuropeanBankAccount was called without a company`,
      );
    }

    const { hasEuropeanBankAccount } = event.values;

    return apolloClient.mutate({
      mutation: SaveCapitalDepositHasEuropeanBankAccountDocument,
      variables: {
        input: {
          companyProfileId: company.companyProfileId,
          hasEuropeanBankAccount: hasEuropeanBankAccount,
        },
      },
    });
  },
};

export default services;
